import styled from 'styled-components'

const MyDiv = styled.div`
 .card_box {
  background: white;
  border-radius: 12px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));

}
  .donut-chart {
    width: 280px;
    height: 299px;
  }
.card-wrapper{
    background: #EEF3FB;
    border-radius: 8px;
}
.notification-button{
    column-gap: 10px;
    padding: 5px 10px;
}
.avatar-icon{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.avatar-icon .chakra-avatar__initials{
    font-size: 16px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
}
.accordion-scroll{
    height: 280px;
    overflow-y: scroll;
}
 .job {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }
`
export default MyDiv
